import OrderPage from "./OrderPage"
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

let hasAlerted = false;

export default function CancelledPage({user})
{
  const navigate = useNavigate();

  useEffect(() =>
  {
    if(!hasAlerted)
    {
      hasAlerted=true;
      setTimeout(() => alert('Sorry, the payment has been cancelled, please try again'), 205)
    }

    navigate('/', {replace: true});
  }, [navigate]);

 
  
  return(
    <div className="main-bg">
      <main>
      <h1>Loading</h1>
    </main>
    </div>


  )
}